<template>
  <div class="admin-login__container">
    <div class="login-title">Administrator Login</div>
    <Form
      ref="formLogin"
      :model="formLogin"
      :rules="rulesForm"
      style="width: 100%"
    >
      <FormItem prop="login">
        <Input
          type="text"
          v-model="formLogin.login"
          placeholder="Login"
          size="large"
        >
        </Input>
      </FormItem>
      <FormItem prop="password">
        <Input
          type="password"
          v-model="formLogin.password"
          placeholder="Password"
          password
          size="large"
        >
        </Input>
      </FormItem>
      <button class="btn" @click.prevent="handleSubmit('formLogin')">
        Continue
      </button>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLogin: {
        login: "",
        password: "",
      },
      rulesForm: {
        login: [
          {
            required: true,
            type: "string",
            message: "Please fill in the login.",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            type: "string",
            message: "Please fill in the password.",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const params = {};
          params["username"] = this.formLogin.login;
          params["password"] = this.formLogin.password;
          this.$store
            .dispatch("loginAdmin", params)
            .then((res) => {
              this.$router.push("/panel");
              this.$Message.success("Welcome");
            })
            .catch((err) => {
              this.$Message.error({
                content: err.response.data.error,
                duration: 5,
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-login__container {
  width: 448px;
  height: 370px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  .login-title {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 20px;
  }
  .btn {
    width: 100%;
    background: #ffe709;
    border-radius: 4px;
    outline: none;
    border: none;
    padding: 16px;
    text-transform: uppercase;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    cursor: pointer;
  }
}
</style>